import { useState, useEffect } from 'react';
import { useApi } from './../../hooks/useApi';

const formatDate = (isoString) => {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export default function usePedidos(selectedDate) {
  const { get } = useApi();
  const [pedidos, setPedidos] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selectedDate) return;

    const fechaISO = selectedDate.toISOString().slice(0, 10);
    console.log('Fecha ISO111:', fechaISO);
    const fetchPedidos = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await get('PedidoFecha', { params: { fecha: fechaISO } });
        console.log('Pedidos obtenidos:', data);
        const pedidosFormateados = data.map(pedido => ({
          ...pedido,
          createdAt: formatDate(pedido.createdAt),
        }));
        setPedidos(pedidosFormateados);
      } catch (err) {
        setError(err.message || 'Error al cargar pedidos');
      } finally {
        setLoading(false);
      }
    };

    fetchPedidos();
  }, [selectedDate,get]);

  return { pedidos, error, loading };
}
